<template>
  <div class="score">
    <div class="score-star" v-html="svg" v-for="star in 5" :class="value >= star ? 'score-active' : ''" @click="model = star"></div>
  </div>
</template>

<script>
export default {
  props: {
    input: null,
    value: null
  },
  mounted () {
    this.$root.track({
      event_type: 'user_interaction',
      interaction_type: 'show-review',
      page_type: 'dreambuddy'
    })
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    },
    svg() {
      return '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" fill="none"><path fill="#fff" d="M14.7 1.1l-4 8.2-9 1.3A2 2 0 0 0 .6 14l6.5 6.3-1.5 9a2 2 0 0 0 2.8 2l8.1-4.2 8 4.3a2 2 0 0 0 3-2l-1.6-9 6.5-6.4a2 2 0 0 0-1-3.4l-9.1-1.3-4-8.2a2 2 0 0 0-3.6 0z"/></svg>'
    }
  }
}
</script>

<style>
.score {
  padding: calc(.5em - 4px);
}
.score-star {
  display: inline-block;
  padding: 4px;
  cursor: pointer;
  transform-origin: 50%;
  transition: fill .2s, opacity .2s;
}
.score-star:hover{
  opacity: .5;
}
.score-active:hover{
  opacity: 1;
}
.score-active{
  animation: 1s rotate ease-in-out;
}
.score-active path{
  fill: #f5d206;
}
.score-active:nth-child(1){
  animation-delay: .1s;
}
.score-active:nth-child(2){
  animation-delay: .2s;
}
.score-active:nth-child(3){
  animation-delay: .3s;
}
.score-active:nth-child(4){
  animation-delay: .4s;
}
.score-active:nth-child(5){
  animation-delay: .5s;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);;
  }
  100% {
    transform: rotate(359.9deg);
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);;
  }
  100% {
    transform: rotate(359.9deg);
  }
}
</style>
